<script>
    import { shipmentStore } from "../../stores/store.js";
    import { fly } from "svelte/transition";

    export let totalOrderDcsn;
    export let totalRequst;
    export let totalShipmntBnt;
    export let isSidePanelOpen; // bindable
    export let toggleRowSelection;
    export let updateMasterTotal;
    export let detailScrollContainer; // bindable
    export let handleDetailScroll;

    $: hasNoValidSelection =
        !($shipmentStore.details || []).some((d) => d.delchk === "Y") ||
        ($shipmentStore.details || []).some(
            (d) =>
                d.delchk === "Y" &&
                (!d.shipmnt_bnt || Number(d.shipmnt_bnt) <= 0),
        );
</script>

{#if $shipmentStore.selectedItem}
    <section in:fly={{ y: 300 }} class="pane detail-box">
        <div class="pane-header detail-bg">
            <h2>
                📝 상세 내역 (거래처: {$shipmentStore.selectedItem.bcnc_nm})
            </h2>
            <div class="header-buttons">
                <button
                    class="save-btn primary"
                    class:disabled={hasNoValidSelection}
                    disabled={hasNoValidSelection}
                    on:click={() => (isSidePanelOpen = true)}
                >
                    주내역 입력 ➔
                </button>
            </div>
        </div>
        {#if $shipmentStore.isDetailLoading}
            <div class="detail-loading-container">
                <div class="detail-spinner"></div>
                <p>상세 내역을 로딩 중입니다...</p>
            </div>
        {:else}
            <div class="summary-bar">
                <div class="sum-item">
                    수주확합계: <span>
                        {totalOrderDcsn.toLocaleString()}
                    </span>
                </div>
                <div class="sum-item">
                    요청합계: <span>
                        {totalRequst.toLocaleString()}
                    </span>
                </div>
                <div class="sum-item highlight">
                    출하수량합계: <span>
                        {totalShipmntBnt.toLocaleString()}
                    </span>
                </div>
            </div>
            <div
                class="table-scroll"
                bind:this={detailScrollContainer}
                on:scroll={handleDetailScroll}
            >
                <table class="mes-table detail-table">
                    <thead>
                        <tr>
                            <th class="fix col-orderno center">수주번호</th>
                            <th class="col-ordersn center">수주순번</th>
                            <th class="col-itemcode center">품목코드</th>
                            <th class="col-itemname left">품목명</th>
                            <th class="col-stndrd left">규격</th>
                            <th class="col-qty center">수주</th>
                            <th class="col-qty center input-col">출하</th>
                            <th class="col-qty center">현재고</th>
                            <th class="col-qty center">요청</th>
                            <th class="col-qty center">기출하</th>
                            <th class="center">납기일</th>
                            <th class="left">비고(출하)</th>
                            <th class="center">품목계정코드</th>
                            <th class="left">품목계정</th>
                            <th class="center">단위코드</th>
                            <th class="center">단위</th>
                            <th class="num">단가</th>
                            <th class="num">수주금액</th>
                            <th class="num">출하금액</th>
                            <th class="center">창고코드</th>
                            <th class="left">창고명</th>
                            <th class="center">출하요청번호</th>
                            <th class="center">출하요청순번</th>
                            <th class="center">TRACKING NO</th>
                            <th class="center">영업그룹코드</th>
                            <th class="left">그룹명</th>
                            <th class="center">출하요청여부</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each $shipmentStore.details as d, i}
                            <tr
                                class:row-checked={d.delchk === "Y"}
                                class:row-shippable={d.delchk !== "Y" &&
                                    Number(
                                        d.orgn_shipmnt_bnt || d.requst_qy || 0,
                                    ) > 0 &&
                                    Number(d.nrmlt_qy || 0) > 0}
                                on:click={() => toggleRowSelection(i)}
                            >
                                <td class="fix center col-orderno">
                                    {d.rcvord_no || ""}
                                </td>
                                <td class="col-ordersn center">{d.rcvord_sn}</td>
                                <td class="col-itemcode center">{d.item_code}</td>
                                <td class="bold col-itemname left">{d.item_nm}</td>
                                <td class="col-stndrd left">{d.stndrd}</td>
                                <td class="center col-qty">{d.rcvord_dcsn_qy}</td>
                                <td class="center input-td col-qty">
                                    <input
                                        type="number"
                                        bind:value={d.shipmnt_bnt}
                                        class="table-input"
                                        on:focus={(e) => e.currentTarget.select()}
                                        on:click={(e) => {
                                            e.stopPropagation();
                                            e.currentTarget.select();
                                        }}
                                        on:input={updateMasterTotal}
                                    />
                                </td>
                                <td class="center red bold col-qty">
                                    {Number(d.nrmlt_qy || 0).toLocaleString()}
                                </td>
                                <td class="center col-qty">{d.requst_qy}</td>
                                <td class="center col-qty">{d.shipmnt_qy}</td>
                                <td class="center">{d.dlivy_de}</td>
                                <td class="left">{d.shipmnt_rm}</td>
                                <td class="center">{d.item_div_code || ""}</td>
                                <td class="left">{d.item_div_nm || "품목"}</td>
                                <td class="center">{d.unit_code}</td>
                                <td class="center">{d.unit_nm}</td>
                                <td class="num">
                                    {Number(d.untpc || 0).toLocaleString()}
                                </td>
                                <td class="num">
                                    {Number(d.splpc || 0).toLocaleString()}
                                </td>
                                <td class="num">
                                    {Number(
                                        d.shipmnt_amount || 0,
                                    ).toLocaleString()}
                                </td>
                                <td class="center">{d.wrhous_code}</td>
                                <td class="left">{d.wrhous_nm}</td>
                                <td class="center">{d.requst_no || ""}</td>
                                <td class="center">{d.requst_sn}</td>
                                <td class="center">{d.trckng_no}</td>
                                <td class="center">{d.bsn_group_code}</td>
                                <td class="left">{d.group_nm}</td>
                                <td class="center">{d.shipmnt_requst_at}</td>
                            </tr>
                        {:else}
                            <tr>
                                <td colspan="27" class="center">
                                    조회된 데이터가 없습니다.
                                </td>
                            </tr>
                        {/each}
                    </tbody>
                </table>
            </div>
        {/if}
    </section>
{/if}

<style>
    /* CSS for ShipmentDetailSection */
    .header-buttons {
        display: flex;
        gap: 10px;
    }
    .pane {
        background: white;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }
    .pane-header {
        padding: 0 12px;
        background: #f8fafc;
        border-bottom: 1px solid #f1f5f9;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 42px;
        flex-shrink: 0;
    }
    .pane-header h2 {
        font-size: 0.8rem;
        margin: 0;
        font-weight: 800;
        color: #475569;
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .detail-box {
        flex: 1.5;
        border: 2px solid #10b981;
        min-height: 0;
    }
    .detail-bg {
        background: #f0fdf4;
    }
    .save-btn.primary {
        background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
        color: white;
        border: none;
        padding: 8px 24px;
        border-radius: 6px;
        font-weight: 800;
        font-size: 0.85rem;
        cursor: pointer;
        transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 4px 6px rgba(37, 99, 235, 0.25);
    }
    .save-btn.primary:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 6px 8px rgba(37, 99, 235, 0.4);
    }
    .save-btn.primary:disabled {
        background: #e2e8f0;
        color: #94a3b8;
        cursor: not-allowed;
        box-shadow: none;
        border-color: #cbd5e1;
    }
    .summary-bar {
        background: #f8fafc;
        padding: 8px 15px;
        display: flex;
        gap: 25px;
        border-bottom: 1px solid #e2e8f0;
        flex-wrap: wrap;
    }
    .sum-item {
        font-size: 0.8rem;
        font-weight: 700;
        color: #64748b;
    }
    .sum-item span {
        color: #1e293b;
        margin-left: 5px;
    }
    .sum-item.highlight {
        color: #c2410c;
    }
    .table-scroll {
        flex: 1;
        overflow: auto;
        border-radius: 0 0 10px 10px;
    }
    .mes-table {
        width: 100%;
        border-collapse: collapse;
        table-layout: auto;
        min-width: max-content;
    }
    .detail-table {
        min-width: 2100px !important;
    }
    .mes-table th {
        position: sticky;
        top: 0;
        background: #f1f5f9;
        padding: 9px 8px;
        font-size: 0.78rem;
        font-weight: 800;
        color: #475569;
        border-bottom: 2px solid #cbd5e1;
        border-right: 1px solid #e2e8f0;
        z-index: 5;
        white-space: nowrap;
        box-sizing: border-box;
    }
    .mes-table th:last-child {
        border-right: none;
    }
    .mes-table td {
        padding: 8px 8px;
        border-bottom: 1px solid #e2e8f0;
        border-right: 1px solid #f1f5f9;
        font-size: 0.85rem;
        cursor: pointer;
        white-space: nowrap;
        box-sizing: border-box;
    }
    .mes-table td:last-child {
        border-right: none;
    }
    .col-orderno {
        width: 105px;
        min-width: 100px;
    }
    .col-ordersn {
        width: 55px;
        min-width: 50px;
    }
    .col-itemcode {
        width: 105px;
        min-width: 95px;
    }
    .col-itemname {
        width: 230px;
        min-width: 200px;
        max-width: 280px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .col-stndrd {
        width: 170px;
        min-width: 150px;
        max-width: 220px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .col-qty {
        width: 58px;
        min-width: 52px;
    }
    .row-checked {
        background: #d1fae5 !important;
        color: #065f46 !important;
        border-left: 6px solid #10b981 !important;
    }
    .row-checked td {
        border-bottom-color: #a7f3d0 !important;
    }
    .left {
        text-align: left !important;
    }
    .center {
        text-align: center !important;
    }
    .num {
        text-align: right !important;
    }
    .bold {
        font-weight: 700;
    }
    .red {
        color: #dc2626 !important;
        font-weight: 800;
    }
    .input-td {
        padding: 4px !important;
    }
    .table-input {
        width: 48px;
        border: 1.5px solid #fb923c;
        text-align: center;
        padding: 3px 2px;
        border-radius: 4px;
        font-weight: 800;
        font-size: 0.85rem;
        background: #ffffff;
        box-sizing: border-box;
    }
    .table-input:focus {
        outline: none;
        border-color: #ea580c;
        box-shadow: 0 0 0 2px rgba(234, 88, 12, 0.2);
    }


    /* 상세내역 전용 로딩 인디케이터 스타일 */
    .detail-loading-container {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: #fafafa;
        padding: 40px;
    }
    .detail-spinner {
        width: 40px;
        height: 40px;
        border: 3.5px solid #f3f3f3;
        border-top: 3.5px solid #10b981; /* Green color to match detail box border */
        border-radius: 50%;
        animation: spin 1s linear infinite;
        margin-bottom: 12px;
    }
    .detail-loading-container p {
        font-size: 0.85rem;
        font-weight: 700;
        color: #64748b;
        margin: 0;
    }
    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    /* 출하 가능(재고 & 잔량 모두 존재) 품목 행 하이라이트 스타일 */
    .row-shippable {
        background: #f0f9ff !important; /* 부드럽고 고급스러운 하늘색 틴트 */
        transition: background-color 0.2s ease;
    }
    .row-shippable:hover {
        background: #e0f2fe !important; /* 호버 시 약간 더 짙은 하늘색 */
    }
    .row-shippable td {
        border-bottom: 1.5px solid #bae6fd !important; /* 행 경계에 연한 블루 보더 제공 */
    }
</style>
